import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {
  proposed: 0,
  accepted: 0,
  amountRatio: 0,
  acceptedAvg: 0,
};

/**
 * @param {import('modules/statistics/types').RevenueReducer} _
 * @param {import('modules/statistics/types').FetchRevenueStatsSuccessAction} action
 * @returns {import('modules/statistics/types').RevenueReducer}
 */
const updateAllData = (_, { payload }) => ({ ...initialState, ...payload });

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_REVENUE_STATS_SUCCESS]: updateAllData,
});
